import * as Yup from "yup";

export const newGlSchema = Yup.object().shape({
  accountType: Yup.string()
    .oneOf(["ASSET", "LIABILITY", "EQUITY", "REVENUE", "EXPENSE"])
    .required("Account type is required"),
  category: Yup.string()
    .oneOf([
      "COLLECTION",
      "SETTLEMENT",
      "WALLET_DEPOSIT",
      "COMMISSION",
      "MERCHANT_LIABILITY",
      "BANK",
      "SUSPENSE",
      "FEE_EXPENSE",
      "OTHER",
    ])
    .required("Category is required"),
  code: Yup.string().required("Account code is required"),
  currency: Yup.string().required("Currency is required"),
  description: Yup.string().required("Description is required"),
  isControlAccount: Yup.boolean().required(
    "Control account selection is required",
  ),
  isPostable: Yup.boolean().required("Postable selection is required"),
  name: Yup.string().required("Account name is required"),
  normalBalance: Yup.string()
    .oneOf(["CREDIT", "DEBIT"])
    .required("Normal balance is required"),
});
